module.exports = __webpack_public_path__ + "media/public/img/one-world-observatory-logo-a51632b7d97b6b83d8ba3670262d383a.svg";